export default "__VITE_ASSET__B43BOMWL__"